// extracted by mini-css-extract-plugin
export default {"formSubtitle":"P9eV2MgUeFICtnDWuugn","divider":"V2KwGWpCJY4CMIRfkwZJ"};